import { useContext } from 'react';
import { useTranslations } from 'js/hooks/i18n';

import { PortletContext } from '../store/context';

export const usePortletTranslations = () => {
    const { tkPrefix } = useContext(PortletContext);

    return useTranslations(tkPrefix);
};
